<template>
    <div>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <VisitConditions :items.sync="visitConditions" :visitid="details.visitId" :latest_conditions="details.latestConditions"></VisitConditions>
            </v-col>
          </v-row>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-btn
                                absolute
                                dark
                                fab
                                bottom
                                right
                                small
                                depressed
                                title="Skopiuj z poprzedniej wizyty"
                                color="primary"
                                @click="copyLatest()"
                                v-if="details != null && details.latestRecoginition"
                        >
                            <v-icon>fa-plus</v-icon>
                        </v-btn>
                        <v-btn
                                absolute
                                dark
                                fab
                                bottom
                                left
                                small
                                depressed
                                title="Wybierz z bazy opisów"
                                color="success"
                                @click="showDescriptionPicker = true"
                        >
                            <v-icon>fa-database</v-icon>
                        </v-btn>
                        <v-container fluid>
                            <v-row>
                                <v-col cols="12">
                                    <tiptap-vuetify v-model="recognition" name="recognition" 
                                                   @input="$emit('recognition', $event)"
                                                   :extensions="extensions"
                                                   :toolbar-attributes="{ color: 'primary' }"
                                                   placeholder="Rozpoznanie opisowe..." />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog v-model="showDescriptionPicker" width="768">
            <DescriptionPicker :type="0" @close="closingPicker" v-if="showDescriptionPicker"></DescriptionPicker>
        </v-dialog>
    </div>
</template>

<script>
    import DescriptionPicker from "../descriptions/DescriptionPicker";
    import VisitConditions from "@/components/visits/VisitConditions";
    import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Blockquote, HardBreak, History } from 'tiptap-vuetify'
    
    export default {
        name: "TherapistVisitRecognition",
        props: ['details','conditions'],
        components: {DescriptionPicker, VisitConditions, TiptapVuetify},
        data() {
            return {
                recognition: this.details != null ? this.details.recognition : null,
                showDescriptionPicker: false,
                extensions: [
                    History,
                    Blockquote,
                    Underline,
                    Strike,
                    Italic,
                    ListItem,
                    BulletList,
                    OrderedList,
                    [Heading, {
                        options: {
                            levels: [1, 2, 3]
                        }
                    }],
                    Bold,
                    Code,
                    Paragraph,
                    HardBreak
                ]
            }
        },
        methods: {
            closingPicker(desc)
            {
                if(desc != null)
                {
                    if(!this.recognition)
                    {
                        this.recognition = desc.description
                    }
                    else
                    {
                        this.recognition += "\r\n"+desc.description;
                    }
                }
                this.showDescriptionPicker = false
            },
            copyLatest() {
                if(this.recognition)
                    this.recognition += this.details.latestRecoginition
                else
                    this.recognition = this.details.latestRecoginition

                this.$emit('recognition', this.recognition)
            }
        },
      computed: {
        visitConditions: {
          get: function() {
            return this.conditions ? this.conditions : []
          },
          set: function(val) {
            this.$emit('update:conditions',val)
          }
        }
      }
    }
</script>

<style scoped>

</style>